import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeEnv } from './lib/env'

// Initialize and validate environment variables
initializeEnv();

createRoot(document.getElementById("root")!).render(<App />);
